// react core
import React, { useState, useEffect } from 'react';

// components
import AjaxSpinner from 'components/commons/ajax_spinner';
import FollowTagButton from 'components/tags/follow_tag_button';

// api
import { get_all_tags_data } from 'commons/api';
import usePageTitle from 'commons/page_title';

// conf
import conf from 'conf/ajax';

export default function QATags(props)
{
    usePageTitle('Browse By Tag');
    const default_tab_state = 'tags-view-all';
    const [tags_list, set_tag_lists] = useState([]);
    const [activeTab, setActiveTab] = useState(default_tab_state);

    useEffect(() =>
    {
        let mounted = true;
        const fetchData = async () =>
        {
            const response =  await get_all_tags_data();
            const data = await response.json();
            if (mounted)
            {
                set_tag_lists(data);
            }
        }
        // call the function
        fetchData()
        // make sure to catch any error
        .catch(console.error);
        return () => mounted = false; // cleanup function
    }, [activeTab]);

    const tagRender = (item) =>
    {
        const url = conf.route.answer + `?tag=${item.id}`;
        return (
            <div key={item.id} className="tag-item">
                <div className='tag-item-header'>
                    <h4><a href={url}>{item.name}</a></h4>
                </div>
                <div className='tag-item-body'>
                    <div dangerouslySetInnerHTML={{ __html: item.description }} />
                    <div>
                        {item.questions === 1 &&
                            <span>1 question</span>
                        }
                        {item.questions !== 1 &&
                            <span>{item.questions || 0} questions</span>
                        }
                        {item.approved_answers === 1 &&
                            <span>1 approved answer</span>
                        }
                        {item.approved_answers !== 1 &&
                            <span>{item.approved_answers || 0} approved answers</span>
                        }
                    </div>
                </div>
                <div className='tag-item-footer'>
                    <a className='button button-small' href={url}><i className="fa-solid fa-person-circle-question"></i> View questions</a>
                    <FollowTagButton tag_id={item.id} follow_state={item.followed} tag_name={item.name}/>
                </div>
            </div>
        );
    };


    const TabContent = ({ id, activeTab, children }) =>
    {
        return (
            activeTab === id ? <div className="tab-pane active">
                {children}
            </div>
                : null
        );
    };

    const TabTitle = ({ id, label, icon, active }) =>
    {
        const base_class = 'nav-link';
        const handleClick = (evt) =>
        {
            evt.preventDefault();
            evt.stopPropagation();
            setActiveTab(id);
        };

        return (
            <li onClick={handleClick} className={active === id ? 'active ' + base_class : base_class}>
                <a className="nav-link" href={id}><i className={icon}></i> {label}</a>
            </li>
        )
    };

    if (!tags_list.length)
    {
        return (
            <div id='tags-view'>
                <AjaxSpinner />
            </div>
        )
    }
    else
    {
        return (<>
            <div id="subheader">
                <div id="subheader-header">
                    <h2>Browse by tag</h2>
                </div>
                <div id="subheader-body">
                    <p>Tags are labels that categorize your questions with similar ones. Browsing within the tags labels helps you find already-answered questions related to your tag of choice.</p>
                </div>
            </div>


            <div id='tags-view'>

                <ul className="nav nav-tabs">
                    <TabTitle key="tags-view-polular" id="tags-view-all" icon="fa-solid fa-tags" label="All tags" active={activeTab} />
                    <TabTitle key="tags-view-followed" id="tags-view-followed" icon="fa-solid fa-bell" label="Followed tags" active={activeTab} />
                </ul>

                <div className="tab-content">
                    <TabContent id="tags-view-all" activeTab={activeTab}>
                        <div className='tags-list'>
                            {tags_list.map(item =>tagRender(item))}
                        </div>
                    </TabContent>
                    <TabContent id="tags-view-followed" activeTab={activeTab}>
                        <div className='tags-list'>
                            {tags_list.filter(item => item.followed === true).map(item =>tagRender(item))}
                        </div>
                    </TabContent>
                </div>


            </div>
            </>);
    }
}
